// extracted by mini-css-extract-plugin
module.exports = {"paxesWrapper":"styles_paxesWrapper__vrwma"};